import React, { Component, Fragment } from 'react';
import { Row, Col, Label, Button, Input, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { HorizontalSeparator } from '../Shared/SharedComponents';
import { API } from '../../Logic/API';
import '../Spacing.css';

const PinPlaceholder = "******";

export class SetupGameTab extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isDropdownOpen : false,
            selectedGame: { Name: "Spiel wählen" },
            groups : []
        };

    }

    toggleDropdown() {
        this.setState(prevState => ({
            isDropdownOpen: !prevState.isDropdownOpen
        }));
    }

    toGroups(data) {
        return data.map(d => ({
            Id: d.Id,
            Name: d.Name,
            Pin: PinPlaceholder
        }));
    }

    selectGame(game) {
        this.setState({ selectedGame: game });

        API.get(`/gamehost/games/${game.Id}/groups`)
            .then(resp => resp.json())
            .then(data => {
                this.setState({ groups: this.toGroups(data) });
            })
            .catch(e => {

            });
    }

    gameSelected() {
        return this.state.selectedGame && this.state.selectedGame.Id;
    }

    changeName(name, group) {
        group.Name = name;
        this.setState({});
    }

    changePIN(pin, group) {
        group.Pin = pin;
        this.setState({});
    }

    sendGroupEMail(group) {

        let mail = this.createEMail([group]);

        this.sendEMail(mail);
    }

    sendAllGroupsEMail() {
        let mail = this.createEMail(this.state.groups);

        this.sendEMail(mail);
    }

    createEMail(groups) {

        let subject = `Kanban Game: ${this.state.selectedGame.Name}`;
        if (groups.length === 1) {
            subject += ` - ${groups[0].Name}`;
        }

        let body = `Willkommen zum Kanban-Spiel. Folgendes Spiel haben wir vorbereitet:%0A%0A`;
        body += `Game: ${this.state.selectedGame.Name}%0A`;
        groups.forEach(g => {
            body += `Gruppe: ${g.Name}%0APin: ${g.Pin}%0A%0A`;
        });
        body += `%0AWir wünschen viel Spass beim Spielen.`;

        return {
            subject: subject,
            body: body
        }
    }

    sendEMail(mail) {
        let link = this.toMailTo(mail);
        window.location.href = link;
    }

    toMailTo(mail) {
        return `mailto:?subject=${mail.subject}&body=${mail.body}`;
    }

    addGroup() {
        this.setState(prevState => ({
            groups: [
                ...prevState.groups,
                {
                    Id: "",
                    Name : "",
                    Pin : ""
                }
            ]
        }));
    }

    updateGroups() {

        let groups = this.state.groups.slice();
        groups.forEach(g => {
            if (g.Pin !== PinPlaceholder) {
                return;
            }
            g.Pin = "";
        });
        
        API.post(`/gamehost/games/${this.state.selectedGame.Id}/groups`, groups)
            .then(resp => resp.json())
            .then(data => {
                this.setState({
                    groups: this.toGroups(data)
                });
            })
            .catch(e => {

            });
    }

    renderLoadingDropdown() {
        return (
            <Dropdown disabled toggle={() => { }}>
                <DropdownToggle caret>
                    Laden...
                </DropdownToggle>
            </Dropdown>
        );
    }

    renderName(game) {
        return `${game.Name} (${new Date(game.CreatedAtUtc).toLocaleDateString('de-CH')})`;
    }

    renderDropdown() {
        if (this.props.isLoadingGames) {
            return this.renderLoadingDropdown();
        }
        return (
            <Dropdown direction="right" isOpen={this.state.isDropdownOpen} toggle={() => this.toggleDropdown()}>
                <DropdownToggle color="primary" caret>
                    {this.state.selectedGame.Name}
                </DropdownToggle>
                <DropdownMenu>
                    {this.props.games.filter(g => g.IsOpen).map(g =>
                        <DropdownItem key={g.Id} onClick={() => this.selectGame(g)}>{this.renderName(g)}</DropdownItem>
                    )}
                </DropdownMenu>
            </Dropdown>
        );
    }

    renderGroups() {
        return (
            <Fragment>
                {this.state.groups.map(g => 
                    <Row className="space-top">
                        <Col>
                            <Input type="text" value={g.Name} placeholder="Gruppe" onChange={e => this.changeName(e.target.value, g)} />
                        </Col>
                        <Col>
                            <Input type="text" value={g.Pin} placeholder="PIN" onChange={e => this.changePIN(e.target.value, g)} />
                        </Col>
                        <Col xs="3">
                            <Button type="button" block color="primary" onClick={() => this.sendGroupEMail(g)}>E-Mail</Button>
                        </Col>
                    </Row>
                    )}
            </Fragment>
            );
    }

    render() {
        let gameDropdown = this.renderDropdown();
        let groups = this.renderGroups();

        return (
            <Fragment>
                <Row className="space-top">
                    <Col><Label>Gruppen</Label></Col>
                </Row>
                <Row>
                    <Col>
                        {gameDropdown}
                    </Col>
                </Row>
                {groups}
                <Row className="space-top space-bottom">
                    <Col>
                        <Button type="button" block color={this.gameSelected() ? "success" : "secondary"} onClick={() => this.addGroup()} disabled={!this.gameSelected()}>Neue Gruppe</Button>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <HorizontalSeparator />
                    </Col>
                </Row>
                <Row className="space-top">
                    <Col>
                        <Button type="button" block color={this.gameSelected() ? "primary" : "secondary"} onClick={() => this.sendAllGroupsEMail()} disabled={!this.gameSelected()}>E-Mail (alle Gruppen)</Button>
                    </Col>
                </Row>
                <Row className="space-top">
                    <Col>
                        <Button type="button" block color={this.gameSelected() ? "primary" : "secondary"} onClick={() => this.updateGroups()} disabled={!this.gameSelected()}>Speichern</Button>
                    </Col>
                </Row>
            </Fragment>
            );
    }
}



// WEBPACK FOOTER //
// ./src/components/Admin/SetupGameTab.jsx